import { GridFields } from 'components';
import { isGlobalProject } from 'config';
import { useTranslation } from 'libs/i18n';
import { Input, Stack, Typography } from 'libs/ui';

import { Field } from '../../../forms';

export const Legal = () => {
  const { t } = useTranslation();
  const isGlobal = isGlobalProject();

  return (
    <Stack spacing={12}>
      <Typography variant="subtitle">
        {t('client.createLegalClient.legal')}
      </Typography>
      <GridFields>
        <Field.Text
          fullWidth
          showRequiredMark
          autoComplete="off"
          label={t('client.createLegalClient.fields.brightCode.label')}
          name="legal.brightCode"
          placeholder={t(
            'client.createLegalClient.fields.brightCode.placeholder'
          )}
        />
        {isGlobal && (
          <Input
            disabled
            fullWidth
            label={t('client.createLegalClient.fields.USTax.label')}
            value={t('common.no')}
          />
        )}

        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.createLegalClient.fields.fullName.label')}
          name="legal.fullName"
          placeholder={t(
            'client.createLegalClient.fields.fullName.placeholder'
          )}
        />
        <Field.Text
          fullWidth
          showRequiredMark
          label={t(
            'client.createLegalClient.fields.personalAccountNumber.label'
          )}
          name="legal.personalAccountNumber"
          placeholder={t(
            'client.createLegalClient.fields.personalAccountNumber.placeholder'
          )}
        />
        <Field.DatePicker
          fullWidth
          showRequiredMark
          label={t(
            'client.createLegalClient.fields.personalAccountOpeningDate.label'
          )}
          name="legal.personalAccountOpeningDate"
          placeholder={t(
            'client.createLegalClient.fields.personalAccountOpeningDate.placeholder'
          )}
        />
      </GridFields>
    </Stack>
  );
};
